// Single app-level API constant.
export const API_BASE = "https://api.profit.sellersside.com";

export const CALENDAR_URL = "https://calendly.com/sellersside/analysis-call";
